import React from "react";
const ListContainer = ({
  height = "20rem",
  width = "100%",
  gap = "",
  columns = "5",
  columnGap = "",
  columnWidth = "1fr",
  rows = "",
  rowGap = "",
  rowHeight = "1fr",
  overflow = "auto",
  ref,
  children,
}) => {
  return (
    <div
      ref={ref}
      style={{
        display: "grid",
        height: height,
        width: width,
        gap: gap ? gap : "",
        gridTemplateColumns: `repeat(${columns}, ${columnWidth})`,
        columnGap: !gap ? columnGap : "",
        gridTemplateRows: `repeat(${rows}, ${rowHeight})`,
        rowGap: !gap ? rowGap : "",
        overflow: overflow,
      }}
    >
      {children}
    </div>
  );
};

export default ListContainer;
